import React, { createContext, useEffect, type ReactNode } from 'react';
import type { Store } from 'redux';
import { fetchProformaReqTypeConfig } from '@atlassian/jira-proforma-request-type-config/src/services/fetch-proforma-rtc/index.tsx';
import {
	fetchProformaReqTypeConfigSuccess,
	setReqTypeContext,
	syncProformaFormStart,
	syncProformaFormSuccess,
} from '../state/actions/index.tsx';

export type ProformaReqConfigProviderProps = {
	cloudId: string;
	extraDefinerId: number | null;
	projectId: number;
	projectType: string;
	store: Store;
	children: ReactNode;
};

export const ProformaStoreContext = createContext<Store | undefined>(undefined);

export const ProformaReqConfigProvider = (props: ProformaReqConfigProviderProps) => {
	const { cloudId, extraDefinerId, projectId, projectType, store, children } = props;

	useEffect(() => {
		if (extraDefinerId) {
			store.dispatch(syncProformaFormStart());
			fetchProformaReqTypeConfig({ cloudId, projectId, requestTypeId: extraDefinerId }).then(
				(response) => {
					if (response !== null) {
						store.dispatch(fetchProformaReqTypeConfigSuccess(response));
					}
					store.dispatch(setReqTypeContext({ cloudId, extraDefinerId, projectId, projectType }));
					store.dispatch(syncProformaFormSuccess());
				},
			);
		}
	}, [cloudId, extraDefinerId, projectId, projectType, store]);

	return <ProformaStoreContext.Provider value={store}>{children}</ProformaStoreContext.Provider>;
};
